import React from "react";
import styled from "styled-components";
import { color } from "../templates/ui";
import IconFacebook from "../atoms/icons/IconFacebook";
import IconX from "../atoms/icons/IconX";
import IconLinkedin from "../atoms/icons/IconLinkedin";
import IconYoutube from "../atoms/icons/IconYoutube";
import IconInstagram from "../atoms/icons/IconInstagram";
import IconTikTok from "../atoms/icons/IconTikTok";

const StyledSocialLinks = styled.ul`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 226px;
`;

const StyledIconTikTok = styled(IconTikTok)`
  fill: ${color.body.base};
  width: 17px;
  height: 19px;
`;

const StyledIconFacebook = styled(IconFacebook)`
  fill: ${color.body.base};
  width: 13px;
  height: 18px;
`;

const StyledIconX = styled(IconX)`
  fill: ${color.body.base};
  width: 23px;
  height: 18px;
`;

const StyledIconLinkedin = styled(IconLinkedin)`
  fill: ${color.body.base};
  width: 23px;
  height: 18px;
`;

const StyledIconYoutube = styled(IconYoutube)`
  fill: ${color.body.base};
  height: 18px;
  width: 25px;
`;

const StyledIconInstagram = styled(IconInstagram)`
  fill: ${color.body.base};
  width: 23px;
  height: 22px;
`;

const IconItem = styled.li`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${props => (props.isFooter ? "0" : "11px 15px 11px 0")};
  &:last-child {
    padding-right: 10px;
  }
`;

const IconLink = styled.a`
  display: inline-block;

  svg {
    display: block;
  }

  &:focus,
  &:hover,
  &:active {
    opacity: 0.75;
  }
`;

const SocialLinks = ({ isFooter }) => (
  <StyledSocialLinks>
    <IconItem>
      <IconLink href="https://www.tiktok.com/@knhb_fun" target="_blank" isFooter={isFooter}>
        <StyledIconTikTok />
      </IconLink>
    </IconItem>
    <IconItem>
      <IconLink href="https://www.facebook.com/KNHB.NL" target="_blank" isFooter={isFooter}>
        <StyledIconFacebook />
      </IconLink>
    </IconItem>
    <IconItem>
      <IconLink href="https://x.com/KNHB_NL" isFooter={isFooter}>
        <StyledIconX />
      </IconLink>
    </IconItem>
    <IconItem>
      <IconLink href="https://www.linkedin.com/company/knhb?trk=biz-companies-cyf" target="_blank" isFooter={isFooter}>
        <StyledIconLinkedin />
      </IconLink>
    </IconItem>
    <IconItem>
      <IconLink
        href="https://www.youtube.com/channel/UC_BWXefInkTSYFdsTYySQCg/videos"
        target="_blank"
        isFooter={isFooter}
      >
        <StyledIconYoutube />
      </IconLink>
    </IconItem>
    <IconItem>
      <IconLink href="https://www.instagram.com/knhb_nl/" target="_blank" isFooter={isFooter}>
        <StyledIconInstagram />
      </IconLink>
    </IconItem>
  </StyledSocialLinks>
);

export default SocialLinks;
